export enum USER_TYPE {
    VIEWER = 'VIEWER',
    PUBLISHER = 'PUBLISHER',
    SUB_ACCOUNT = 'SUB_ACCOUNT'
}
